import { Stack } from "@altimateai/lego";
import { Logo } from "../logo";

interface MobileBaseContainerProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const MobileBaseContainer = ({
  children,
  footer,
}: MobileBaseContainerProps) => {
  return (
    <div className="al-h-full al-grid al-grid-cols-1 al-m-0 al-w-screen al-overflow-y-auto al-overflow-x-hidden">
      <div className="al-p-0">
        <Stack
          direction="column"
          align="start"
          className="al-w-full al-py-10 al-px-[5vw]"
        >
          <div className="al-w-[60%]">
            <Logo />
          </div>
          <div className="al-min-h-[40px] al-flex-grow" />
          <Stack direction="column" className="al-w-[60%]">
            {children}
          </Stack>
          {footer}
        </Stack>
      </div>
    </div>
  );
};

export default MobileBaseContainer;
